const getDisplayName = (Component: any) => Component.displayName || Component.name
export default getDisplayName
